var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoToGoogleCalendar24 = function SvgGoToGoogleCalendar24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#go-to-google-calendar-24_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m16.737 7.263-4.263-.474-5.21.474L6.788 12l.474 4.737 4.737.592 4.737-.592.474-4.855-.474-4.619Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M16.737 21 21 16.737l-2.131-.947-2.132.947-.947 2.132.947 2.131Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M6.316 18.869 7.263 21h9.474v-4.263H7.263l-.947 2.132Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M4.421 3A1.42 1.42 0 0 0 3 4.421v12.316l2.132.947 2.131-.947V7.263h9.474l.947-2.131L16.737 3H4.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#188038",
    d: "M3 16.737v2.842A1.42 1.42 0 0 0 4.421 21h2.842v-4.263H3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC04",
    d: "M16.737 7.263v9.474H21V7.263l-2.131-.947-2.132.947Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1967D2",
    d: "M21 7.263V4.421A1.42 1.42 0 0 0 19.58 3h-2.842v4.263H21Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    fillRule: "evenodd",
    d: "M14.314 14.314H10.07l1.414-1.415L5.12 6.536A1 1 0 1 1 6.536 5.12l6.364 6.364 1.414-1.414v4.243Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "go-to-google-calendar-24_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3 3h18v18H3z"
  })))));
};
export default SvgGoToGoogleCalendar24;